export default __webpack_public_path__ + "static/media/DSC.173b5779.png";